import { AbstractIcon } from "./abstract";
import { componentsRegistryService } from "cruzo";

/** IBM Carbon Design System — paragraph icon (32px artboard). */
export class ParagraphIcon extends AbstractIcon {
  static selector = "paragraph-icon";

  getHTML() {
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" aria-hidden="true">
      <path d="M27,4H13a7,7,0,0,0,0,14V28h2V6h5V28h2V6h5ZM13,16A5,5,0,0,1,13,6Z"/>
    </svg>`;
  }
}

componentsRegistryService.define(ParagraphIcon);
